import React, { useEffect, useState } from 'react';
import { CircularProgress, Tooltip, type ButtonProps } from '@mui/material';

import { Button } from '../../components';

export type CountdownButtonProps = ButtonProps & {
  text: string;
  loading: boolean;
  countdownTime: { time: number };
  forceDisable?: boolean;
};

export const CountdownButton: React.FunctionComponent<
  CountdownButtonProps
> = props => {
  const {
    text,
    countdownTime,
    loading,
    className,
    disabled,
    forceDisable,
    ...other
  } = props;
  const [remainingTime, setRemainingTime] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isCountingDown, setIsCountingDown] = useState(false);

  let timerInterval: ReturnType<typeof setInterval>;

  useEffect(() => {
    setRemainingTime(countdownTime.time);
  }, [countdownTime]);

  useEffect(() => {
    clearInterval(timerInterval);
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (remainingTime > 0) {
      setIsCountingDown(true);
      timerInterval = setTimeout(() => {
        setRemainingTime(prev => prev - 1);
      }, 1000);
      return () => {
        clearTimeout(timerInterval);
      };
    } else {
      setIsCountingDown(false);
    }
  }, [remainingTime]);

  return (
    <div>
      <Tooltip
        title={
          isCountingDown || isLoading ? `Please wait for processing` : null
        }
      >
        <span>
          <Button
            disabled={isCountingDown || isLoading || forceDisable}
            {...other}
            className={`${className} ${isCountingDown ? '!normal-case' : ''}`}
          >
            {isLoading ? (
              <CircularProgress
                color="inherit"
                className="!w-[25px] !h-[25px]"
              />
            ) : isCountingDown ? (
              <div>{remainingTime}s</div>
            ) : (
              text
            )}
          </Button>
        </span>
      </Tooltip>
    </div>
  );
};
